import React from 'react'
import { Row, Col } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class StoryDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            storyInfo: {
                name: '',
                image: '',
                title: '',
                content: '',
                desc: '',
            },
            storyInfoLoaded: false,
            dataLoaded: false,
            imageLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    getStoryInfo(id, lang, token) {
        return new Promise((resolve, reject) => {
            api.getStoryInfo(id, lang, token)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    async componentWillMount() {
        const accessToken = cookies.get('accessToken')
        let arrPromise = [
            this.getStoryInfo(this.props.match.params.storyId, this.props.i18n.language, accessToken).then((storyInfo) => this.setState({ storyInfoLoaded: true, storyInfo })),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <Row className="w-100 mx-0 pt-120">
                <Col md={8} sm={12} className="px-30">
                    <div className="story card px-0 pt-20">
                        <div className="link text-uppercase md-font-size">
                            {
                                this.state.storyInfoLoaded ?
                                    <React.Fragment>
                                        <span>{t('story-story')} / {t('story-story')} </span>
                                        <span>{this.state.storyInfo.name}</span>
                                    </React.Fragment>
                                    :
                                    <Skeleton width={'80%'} style={{ verticalAlign: 'inherit' }} />
                            }
                        </div>
                        <div className="name xl-font-size">
                            {
                                this.state.storyInfoLoaded ?
                                    <span>{this.state.storyInfo.name}. {this.state.storyInfo.title}</span>
                                    :
                                    <Skeleton />
                            }
                        </div>
                        {
                            this.state.storyInfoLoaded ?
                                this.state.storyInfo.content &&
                                <div className="card-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.state.storyInfo.content }}></div>
                                :
                                <div className="card-desc md-font-size pt-5"><Skeleton count={5} /></div>
                        }
                    </div>
                </Col>
                <Col md={4} sm={12} className="px-30">
                    <div className="story card px-0 pt-20">
                        <div className="card-header p-0">
                            {!this.state.imageLoaded && <Skeleton className="card-img" height={300} />}
                            <img onLoad={() => this.setState({ imageLoaded: true })} src={this.state.storyInfo.image ? `${this.state.imageUrl}/${this.state.storyInfo.image}` : "data:,"} className={`card-img${this.state.imageLoaded ? '' : ' d-none'}`} alt=""></img>
                        </div>
                        <div className="card-body pt-0">
                            <div className="name xl-font-size">{this.state.storyInfoLoaded ? this.state.storyInfo.name : <Skeleton width={'80%'} />}</div>
                            {
                                this.state.storyInfoLoaded ?
                                    <div className="desc md-font-size" dangerouslySetInnerHTML={{ __html: this.state.storyInfo.desc }}></div>
                                    :
                                    <div className="desc md-font-size">
                                        <Skeleton count={2} />
                                    </div>
                            }

                        </div>
                    </div>
                </Col>
            </Row>
        )
    }
}

StoryDesc.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(StoryDesc)


// WEBPACK FOOTER //
// ./src/views/Story/StoryDesc.jsx